module.exports = __webpack_public_path__ + "img/facebook.2be2387.svg";